import {
    orderColumnWithContext,
    conceptionChartDimensionOrderingWithContext,
} from './columnOrdering';
import { formatDataToHistogramWithContext } from './histograms';
import {
    mergeChartDimensionsWithContext,
    initialMergeChartDimensionStrategy,
    conceptionMergeChartDimensionStrategy,
} from './mergeColumns';
import { normalizeDataWithContext } from './normalize';
import { pivotMultimetricsWithContext } from './pivot';
import {
    OrderingTransformation,
    FormatTransformation,
    UnformatedTransformation,
} from './types';

type FormatVizPipelines = [
    UnformatedTransformation,
    UnformatedTransformation,
    OrderingTransformation,
    FormatTransformation,
    FormatTransformation,
];

export const initialFormatVizPipeline: FormatVizPipelines = [
    pivotMultimetricsWithContext,
    mergeChartDimensionsWithContext(initialMergeChartDimensionStrategy),
    orderColumnWithContext,
    formatDataToHistogramWithContext,
    normalizeDataWithContext,
];

export const chartConceptionFormatVizPipeline: FormatVizPipelines = [
    pivotMultimetricsWithContext,
    mergeChartDimensionsWithContext(conceptionMergeChartDimensionStrategy),
    conceptionChartDimensionOrderingWithContext,
    formatDataToHistogramWithContext,
    normalizeDataWithContext,
];
